import { Injectable } from '@angular/core';
import { Database, push, ref, update, get, remove, set, orderByChild, query, equalTo } from '@angular/fire/database';
import { LogService } from './log.service';
import { Entity } from '../data-models/Entity';
import { take, map } from 'rxjs/operators';
import { EntityHierarchy } from '../data-models/entity-hierarchy';
import { HttpClient } from '@angular/common/http';
import { GlobalsService } from './globals.service';
import { from } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class EntityService {
  sEndpoint: string = 'https://apis.zenithr.net/api/';//'http://localhost:52619/api/';https://apis.zenithr.net/api/
  coreAPI: string = 'https://localhost:44385/api/';

  constructor(private db: Database, private logService: LogService, private http: HttpClient, private globals: GlobalsService) {
    this.sEndpoint = this.globals.sEndpoint;
    this.coreAPI = this.globals.coreAPI;

  }


  createEntity(entity: Entity) {
    const entityRef = ref(this.db, `/TenantData/${entity.tenantKey}/Entities/${entity.key}`);

    set(entityRef, entity)
      .then(() => {
        this.logService.submitLog(4, 'EntityService.createEntity()', 'Task Completed', { entity });
      })
      .catch((error) => {
        this.logService.submitLog(4, 'EntityService.createEntity()', 'Task Failed', { entity });
      });
  }

  createNewEntity(entity: Entity) {
    return this.http.post(this.coreAPI + 'Entity/CreateEntity', entity);
  }

  coreUpdateCompany(entity: Entity) {
    return this.http.post(this.coreAPI + 'Entity/UpdateEntity', entity);
  }

  updateEntity(entity: Entity) {
    const entityRef = ref(this.db, `/TenantData/${entity.tenantKey}/Entities/${entity.key}`);
    return update(entityRef, entity);
  }

  deleteEntity(entity: Entity) {
    const entityRef = ref(this.db, `/TenantData/${entity.tenantKey}/Entities/${entity.key}`);
    return remove(entityRef);
  }


  createCompany(request) {
    return this.http.post(this.sEndpoint + 'Entity/CreateCompany', request);
  }


  updateCompany(request) {
    return this.http.post(this.sEndpoint + 'Entity/UpdateCompany', request);
  }

  fetchEntitiesOnce(tenantKey: string, companyKey?: string) {
    const entitiesRef = ref(this.db, `/TenantData/${tenantKey}/Entities/`);

    const entitiesQuery = companyKey
      ? query(entitiesRef, orderByChild('companyEntityKey'), equalTo(companyKey))
      : entitiesRef;

    return from(get(entitiesQuery)).pipe(
      map(snapshot => {
        const data = snapshot.val() || {};

        return Object.entries(data).map(([key, value]) => ({
          key,
          ...(value as Entity)
        }));
      })
    );
  }

  fetchEntities(tenantKey: string) {
    const entitiesRef = ref(this.db, `/TenantData/${tenantKey}/Entities/`);

    return from(get(entitiesRef)).pipe(
      map(snapshot => {
        const data = snapshot.val() || {};
        // Convert object to array with keys
        return Object.entries(data).map(([key, value]) => ({ key, ...(value as Entity) }));
      })
    );
  }

  fetchEntity(tenantKey: string, companyKey: string) {
    const path = `/TenantData/${tenantKey}/Entities/${companyKey}`;
    const entityRef = ref(this.db, path);

    // Wrap the promise in an observable
    return from(get(entityRef)).pipe(
      map(snapshot => {
        const val = snapshot.val();
        return { key: snapshot.key, ...val } as Entity & { key: string };
      })
    );
  }


  structureEntities(entities: Entity[], rootCompanyKey: string) {
    let companyEntites: Entity[] = [];
    for (let i = 0; i < entities.length; i++) {
      let entity = entities[i];
      if (entity.companyEntityKey == rootCompanyKey) {
        companyEntites.push(entity);
      }
    }
    return companyEntites;
  }

}
